export const VisualInspectSectionDataP621 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'F193VisuallyInspect',
                label: 'Visually inspect all components of the speed sensor including probe, transducer and junction boxes for signs of damage, corrosion, water/oil ingress, loose connections and security of mounting. Inspect condition of cabling, glanding and earthing. Check tightness of probe in the mounting base on the rotating equipment. Verify that overspeed device is fully powered and does not have any alarm lamps turned on.',
                value: formData.F193VisuallyInspect,
                isRequired: true,
                isMultiline: true,
                xs: 12,
                width: '50%',
                inputWidth: '50%',
                marginTop: '15px',
                alignItems: 'inherit'
            }]
        },
        {
            key: 2,
            fields: [{
                key: 'F194DiagnosticMessages',
                label: 'Retrieve any diagnostic messages',
                value: formData.F194DiagnosticMessages,
                isMultiline: true,
                xs: 12,
                width: '50%',
                inputWidth: '50%',
                alignItems: 'inherit',
                marginTop: '15px',
            }]
        }]
});
